import * as i0 from '@angular/core';
import { inject, signal, Directive, HostListener } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
let NgxRouterLoadingDirective = /*#__PURE__*/(() => {
  class NgxRouterLoadingDirective {
    constructor(elementRef) {
      this.elementRef = elementRef;
      this.router = inject(Router);
      this.navigating = signal(false);
      this.clicking = signal(false);
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          this.navigating.set(true);
        }
        if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
          this.navigating.set(false);
          this.elementRef.nativeElement.classList.remove('ngx-router-loading');
        }
      });
    }
    onClick(event) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.clicking.set(true);
      this.timer = setTimeout(() => {
        if (this.navigating()) {
          this.elementRef.nativeElement.classList.add('ngx-router-loading');
        }
        this.clicking.set(false);
      }, 20);
    }
    static {
      this.ɵfac = function NgxRouterLoadingDirective_Factory(t) {
        return new (t || NgxRouterLoadingDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgxRouterLoadingDirective,
        selectors: [["", "ngxRouterLoading", ""]],
        hostBindings: function NgxRouterLoadingDirective_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function NgxRouterLoadingDirective_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
        },
        standalone: true
      });
    }
  }
  return NgxRouterLoadingDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ngx-router-loading
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxRouterLoadingDirective };
